export const Cases = () => {
  return (
    <div className="flex justify-center">
      <div className="px-[15rem] py-[50px] w-[1920px]">
        <div className="text-[#333] text-center font-['Alibaba_PuHuiTi_3.0'] text-[45px] font-bold leading-[120%] tracking-[4.5px] mb-[50px]">
          客户案例
        </div>
        <div className="mt-[50px]">
          <div className="flex">
            <img src="/imgs/tiktok/case-1.png" className="w-1/2 h-[430px]" />
            <div className="p-[40px] flex-1 h-[430px] bg-white rounded-tr-[10px] shadow-[0px_4px_8px_0px_rgba(0,0,0,0.08)]">
              <div className="flex items-center text-zinc-800 text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                <img
                  src="/imgs/tiktok/title-1.svg"
                  className="w-[50px] h-[50px] mr-[8px]"
                />
                某MCN机构多账号TK直播
              </div>
              <CaseItem
                title="用户场景"
                description="TikTok娱乐直播公司，多主播多账号同时直播。"
              />
              <CaseItem
                title="客户痛点"
                description="自建机房+专线，网络运维成本高；由于国际网络经常性波动和TK官方策略变更，运维人员难以处理，导致网络不稳定，直播频繁跳红绿灯，甚至无法开播或者0播，影响业务正常经营。"
              />
              <CaseItem
                title="解决方案"
                description="接入光年无界TikTok直播专线"
              />
              <CaseItem
                title="使用效果"
                description="接入光年无界TikTok直播专线服务后，网络稳定，直播间活跃人数稳定在10K+，公司业务快速发展"
              />
            </div>
          </div>
          <div className="flex">
            <div className="p-[40px] flex-1 h-[430px] bg-white rounded-tr-[10px] shadow-[0px_4px_8px_0px_rgba(0,0,0,0.08)]">
              <div className="flex items-center text-zinc-800 text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                <img
                  src="/imgs/tiktok/title-2.svg"
                  className="w-[50px] h-[50px] mr-[8px]"
                />
                某TikTok矩阵运营公司
              </div>
              <CaseItem
                title="用户场景"
                description="该公司主要是在TikTok上发矩阵短视频做营销，然后以小黄车的方式卖货"
              />
              <CaseItem
                title="客户痛点"
                description="用了外部找的组建方案，路由器+用了外部找的组建方案，路由器+软件，用路由器跨境，软件对应每个设备，设备每个都需要单独配置，下载软件，配置IP，由于设备较多，每次维护起来特别麻烦。并且经历过一次封号后，整个公司的账号被关联，权重高的账号被限制了流量，其他账号都被封禁"
              />

              <CaseItem
                title="使用效果"
                description="无需再配置IP了，所有设备连接光年无界直播专线网络，后台一键选择设备对应的IP，以前需要5个人24小时监管设备情况并配置，现在只需要1个人后台勾选即可，管理成本大大降低。并且也没有发生关联情况了，业务顺利进行。"
              />
            </div>
            <img src="/imgs/tiktok/case-2.png" className="w-1/2 h-[430px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

const CaseItem = (props: { title: string; description: string }) => {
  return (
    <div>
      <div className="mt-[20px] self-stretch justify-start text-slate-700 text-base font-medium font-['Alibaba_PuHuiTi_3.0']">
        {props.title}
      </div>
      <div className="mt-[6px] self-stretch justify-start text-slate-700 text-sm font-light font-['Alibaba_PuHuiTi_3.0']">
        {props.description}
      </div>
    </div>
  );
};
